import { RefreshCcw } from 'lucide-react';
import { useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';

interface SignatureInputProps {
  disabled: boolean;
  className?: string;
}

export const SignatureInput = ({ disabled, className }: SignatureInputProps) => {
  const sigCanvas = useRef<SignatureCanvas>(null);

  const reset = () => {
    sigCanvas.current?.clear();
  };

  return (
    <div className="flex items-center gap-2 w-full">
      {/* Signature box */}
      <div className="relative flex-1">
        <SignatureCanvas
          ref={sigCanvas}
          penColor="#621C43"
          canvasProps={{
            className: `${className} h-40 border-[#C0275E] border-2 rounded-md w-full`,
            style: { touchAction: 'none' },
          }}
        />

        {/* Placeholder text */}
        <span className="absolute top-3 left-3 text-sm text-[#C0275E] pointer-events-none">
          Draw your signature in this box
        </span>
      </div>

      {/* Reset icon */}
      <button type="button" onClick={reset} disabled={disabled} className="text-[#7a3a4c]">
        <RefreshCcw size={18} />
      </button>
    </div>
  );
};
